import { useEffect, useState } from 'react';

/** Tailwind's `lg` breakpoint — the worktop switches from the mobile to the desktop grid here. */
const DESKTOP_QUERY = '(min-width: 1024px)';

function matchesDesktop(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(DESKTOP_QUERY).matches;
}

/**
 * Reactive desktop-breakpoint flag. True at/above Tailwind's `lg` (1024px), where the
 * worktop renders the 7-col desktop grid; false below, where it renders the 5-col mobile
 * grid. Initialized synchronously so the first render is already correct (no flash), and
 * updates on viewport changes. Falls back to mobile when `matchMedia` is unavailable
 * (jsdom/SSR) so tests stay deterministic.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(matchesDesktop);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(DESKTOP_QUERY);
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isDesktop;
}
